import { render } from "./singlePostViewExplanation.vue?vue&type=template&id=4c75bc26"
const script = {}

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__